import { Box, Button, styled } from '@mui/material';
import { CenteredFlexBox } from '../layout';

export const StyledButtonSmallWhite = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 'fit-content',
  gap: theme.spacing(1),
  padding: theme.spacing(2, 5),
  borderRadius: theme.spacing(2),
  fontSize: 16,
  fontWeight: 500,
  boxShadow: 'none',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  color: theme.customColors.primary100,
  backgroundColor: theme.palette.common.white,

  '&:hover': {
    boxShadow: 'none',
    color: theme.customColors.primary100,
    backgroundColor: theme.palette.common.white,
  },
}));

export const StyledButtonSmallBlue = styled(StyledButtonSmallWhite)(({ theme }) => ({
  padding: theme.spacing(2, 3.5),
  color: theme.palette.common.white,
  backgroundColor: theme.customColors.primary100,

  '&:hover': {
    color: theme.palette.common.white,
    backgroundColor: theme.customColors.purple80,
  },
}));

export const StyledModalButton = styled(Button)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 500,
  padding: theme.spacing(4, 2),
  borderRadius: theme.spacing(2),

  boxShadow: 'none',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  color: theme.palette.common.white,
  backgroundColor: theme.customColors.primary100,

  '&:hover': {
    boxShadow: 'none',
    color: theme.palette.common.white,
    backgroundColor: theme.customColors.purple80,
  },
}));

export const StyledButtonOutlinedPrimary = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: theme.spacing(1, 5),
  fontSize: 16,
  fontWeight: 500,
  borderRadius: 8,
  textTransform: 'none',
  backgroundColor: 'transparent',
  whiteSpace: 'nowrap',
  color: theme.customColors.primary100,
  border: `1px solid ${theme.customColors.primary100}`,
}));

export const StyledArrowButtonTwo = styled(CenteredFlexBox)(({ theme }) => ({
  position: 'absolute',
  width: 38,
  height: 38,
  cursor: 'pointer',
  borderRadius: '50%',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.customColors.neutral300}`,
}));

export const StyledDatePicker = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: theme.spacing(1.5, 4),
  borderRadius: theme.spacing(10),
  color: theme.customColors.black,
  backgroundColor: theme.customColors.primary10,
}));

export const PlusButton = styled(Button)(({ theme }) => ({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  textTransform: 'none',
}));

export const CustomButton = styled(Button)(({ theme }) => ({
  padding: '20px',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '100%',
  borderRadius: theme.spacing(2),
  color: theme.palette.background.paper,
  backgroundColor: theme.customColors.primary100,
  '&:hover': {
    backgroundColor: theme.customColors.purple80,
  },
}));
